<app-action-modal
  #modal
  size="md"
  customModalClass="link-flow-modal"
  submitButtonClass="lty-btn-primary"
  [disabled]="busy()"
  [submitDisabled]="!control.value"
  (submitted)="submit()"
  (closed)="onClosed()"
>
  <ng-container mainTitle>
    <span class="link-flow-modal__title">{{ title() }}</span>
  </ng-container>

  <ng-container subtitle>
    @if (subtitle()) {
      <span class="link-flow-modal__subtitle">{{ subtitle() }}</span>
    }
  </ng-container>

  <div body class="lty-form mt-32 mb-32" ngbAutofocus tabindex="-1">
    @if (modalOpen) {
      <app-flow-select
        [label]="label()"
        [control]="control"
        [familyMemberId]="familyMemberId()"
        [displayId]="displayId()"
        [excludeFlowId]="excludeFlowId()"
        [withPolicyOnly]="withPolicyOnly()"
        [insuranceType]="insuranceType()"
        [purpose]="purpose()"
        [required]="true"
        [withCreatedOn]="true"
      />
    }
  </div>

  <ng-container submitButtonLabel>{{ submitLabel() }}</ng-container>
</app-action-modal>
